// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".experts-content .experts-avatar-wrapper{width:70px;height:70px;border-radius:50%;background-color:#e8e8ed;display:flex;justify-content:center;align-items:center;position:relative;flex:none;cursor:pointer}.experts-content .experts-avatar-wrapper img.avatar{border-radius:50%;width:inherit;height:inherit;object-fit:cover;border:1px solid #e8e8ed}.experts-content .experts-avatar-wrapper img.default-avatar{width:40px;position:relative;top:-4px}\n", ""]);
// Exports
module.exports = exports;
